import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { getEsppQuoterCachedValue, initEsppQuoterCacheSessionLifecycle, QUOTER_CACHE_STORAGE_KEYS, SALE_TYPES_CACHE_STORAGE_KEY, setEsppQuoterCachedValue } from '../cache-storage/espp-quoter-cache-storage';

@Injectable()
export class SaleTypeService {

    private saleTypesCache = new Map<string, { [key: string]: string }[]>();

    constructor(private http: HttpClient) {
        initEsppQuoterCacheSessionLifecycle(QUOTER_CACHE_STORAGE_KEYS);
    }

    public getSaleTypes(quoteType: string, dealershipId?: string | number): Observable<{ [key: string]: string }[]> {
        const cacheKey = `${dealershipId ?? ''}:${quoteType}`;
        const cachedSaleTypes = this.saleTypesCache.get(cacheKey);
        if (cachedSaleTypes?.length) {
            setEsppQuoterCachedValue(SALE_TYPES_CACHE_STORAGE_KEY, cacheKey, cachedSaleTypes);
            return of(cachedSaleTypes);
        }

        const storedSaleTypes = getEsppQuoterCachedValue<{ [key: string]: string }[]>(SALE_TYPES_CACHE_STORAGE_KEY, cacheKey);
        if (storedSaleTypes?.length) {
            this.saleTypesCache.set(cacheKey, storedSaleTypes);
            return of(storedSaleTypes);
        }

        const opts = { params: { quote_type: quoteType} };
        return this.http.get<{ [key: string]: string }[]>('api/v1/espp/sale_types',opts)
            .pipe(
                tap((saleTypes) => {
                    if (saleTypes.length > 0) {
                        this.saleTypesCache.set(cacheKey, saleTypes);
                        setEsppQuoterCachedValue(SALE_TYPES_CACHE_STORAGE_KEY, cacheKey, saleTypes);
                    }
                }),
                catchError(error => of([]))
            )
    }
}
